<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Staff</h2>
			<v-btn color="primary" @click="showAdd()">Add Staff</v-btn>
		</div>

		<div>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th>Id</th>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Title</th>
							<th>Email</th>
							<th>Status</th>
							<th>Emailed</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(entity, idxEntity) in entityList" :key="idxEntity">
							<td>{{entity.id}}</td>
							<td>{{entity.firstName}}</td>
							<td>{{entity.lastName}}</td>
							<td>{{entity.title}}</td>
							<td>{{entity.email}}</td>
							<td>{{entity.active ? 'Active' : 'Inactive'}}</td>
							<td>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-bind="attrs"
											v-on="on"
											:color="entity.emailed ? 'success' : ''"
											@click="
											emailList.push(entity),
												(dialogEmailConfirmation = true)
										"
										>mdi-email-send</v-icon>
									</template>
									<span>{{entity.dataMap.sendTime ? entity.dataMap.sendTime : 'Not yet sent'}}</span>
								</v-tooltip>
							</td>
							<td>
								<v-btn @click="showEdit(entity)" icon>
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
								<v-btn @click="deleteStaff(entity.id)" icon>
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>

		<v-dialog v-model="dialogAdd" persistent no-click-animation fullscreen transition="dialog-bottom-transition">
			<v-card tile>
				<v-card-title class="headline">
					Add Staff
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form ref="formAdd" v-model="valid" @submit.prevent="addStaff()">
						<v-row class="d-flex justify-center mt-4">
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entityAdd.email"
									label="Email"
									:rules="[(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
									dense
									rounded
									filled
								></v-text-field>

								<v-text-field
									v-model="entityAdd.firstName"
									label="First Name"
									:rules="[(v) => !!v || 'First Name is required']"
									dense
									rounded
									filled
									required
								></v-text-field>

								<v-text-field v-model="entityAdd.lastName" label="Last Name" :rules="[(v) => !!v || 'Last Name is required']" dense rounded filled required></v-text-field>

								<v-text-field v-model="entityAdd.title" label="Title" dense rounded filled></v-text-field>

								<v-text-field
									v-model="entityAdd.password"
									type="password"
									label="Password"
									:rules="[(v) => !!v || 'Please specify password']"
									dense
									rounded
									filled
								></v-text-field>

								<v-switch v-model="entityAdd.active" inset prepend-icon="mdi-list-status" :label="entityAdd.active ? 'Active' : 'Inactive'"></v-switch>

								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" rounded depressed>Save</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" persistent no-click-animation fullscreen transition="dialog-bottom-transition">
			<v-card tile>
				<v-card-title class="headline">
					Edit Staff
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form ref="formEdit" v-model="valid" @submit.prevent="editStaff()">
						<v-row class="d-flex justify-center mt-4">
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entityEdit.email"
									label="Email"
									:rules="[(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
									disabled
									dense
									rounded
									filled
								></v-text-field>

								<v-text-field
									v-model="entityEdit.firstName"
									label="First Name"
									:rules="[(v) => !!v || 'First Name is required']"
									dense
									rounded
									filled
									required
								></v-text-field>

								<v-text-field v-model="entityEdit.lastName" label="Last Name" :rules="[(v) => !!v || 'Last Name is required']" dense rounded filled required></v-text-field>

								<v-text-field v-model="entityEdit.title" label="Title" dense rounded filled></v-text-field>

								<v-switch v-model="entityEdit.active" inset prepend-icon="mdi-list-status" :label="entityEdit.active ? 'Active' : 'Inactive'"></v-switch>

								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" rounded depressed>Save</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEmailConfirmation" max-width="400px">
			<v-card>
				<v-card-title class="headline info justify-center pa-12" primary-title>
					<v-icon color="white" size="120">mdi-email-alert-outline</v-icon>
				</v-card-title>

				<v-card-text class="pa-6" style="text-align: center">
					<p style="text-align: justify">Do you want to continue sending the email?</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="default" @click="
							(emailList = []), (dialogEmailConfirmation = false)
						">Cancel</v-btn>
					<v-btn color="primary" @click="sendNotification(emailList)">Confirm</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			dialogAdd: false,
			dialogEdit: false,
			entityAdd: { active: false, dataMap: {} },
			entityEdit: { active: false, dataMap: {} },
			entityList: [],
			dialogEmailConfirmation: false,
			emailList: []
		};
	},
	mounted() {
		this.listStaff();
	},
	methods: {
		listStaff() {
			axios
				.get("/system/staff/list?tenantId=" + this.$store.state.principal.tenantId)
				.then(response => {
					this.entityList = response.data;
				})
				.catch(() => {});
		},
		showAdd() {
			this.entityAdd = { active: false, dataMap: {} };
			this.dialogAdd = true;
			this.$refs.formAdd.resetValidation();
		},
		closeAdd() {
			this.dialogAdd = false;
		},
		showEdit(item) {
			this.entityEdit = item;
			this.dialogEdit = true;
			this.$refs.formEdit.resetValidation();
		},
		closeEdit() {
			this.dialogEdit = false;
		},
		deleteStaff(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios
					.post("/system/staff/delete", { id })
					.then(() => {
						this.listStaff();
					})
					.catch(() => {});
			}
		},
		addStaff() {
			let formData = new FormData();

			formData.append("entity", JSON.stringify(this.entityAdd));
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios
				.post("/system/staff/add", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.closeAdd();
					this.listStaff();
				});
		},
		editStaff() {
			let formData = new FormData();

			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios
				.post("/system/staff/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.closeEdit();
					this.listStaff();
				});
		},
		sendNotification(emailList) {
			this.dialogEmailConfirmation = false;
			let formData = new FormData();
			formData.append("entityList", JSON.stringify(emailList));
			axios
				.post("/system/staff/send/notification", formData)
				.then(() => {
					this.listStaff();
					this.emailList = [];
				})
				.catch(() => {});
		},
	}
};
</script>